/* Rayzox — pop-up de choix de version (système officiel de variantes Shopify)
   - Les boutons radio viennent de product.options_with_values
   - Variante = correspondance exacte des options cochées dans product.variants
   - La couleur Blanc/Noir (si le produit n'a pas d'option couleur) part en propriété de ligne
   - Ajout : /cart/add.js avec l'id résolu au moment du clic, puis vérification de la réponse */
(() => {
  const form = document.querySelector('[data-rz-form]');
  const dataEl = document.querySelector('[data-rz-variants]');
  const ov = document.getElementById('rzov');   // absent sur la page produit : le bloc est alors affiché directement
  if (!form || !dataEl) return;

  let variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const $$ = (s) => [...document.querySelectorAll(s)];
  const idInput = form.querySelector('input[name="id"]');
  const msg = form.querySelector('[data-rz-msg]');
  const groups = [...form.querySelectorAll('[data-rz-option]')];   // vraies options Shopify
  const colorGroup = form.querySelector('[data-rz-color]');         // couleur "finition" (propriété)
  const submit = form.querySelector('[data-rz-submit]');
  const design = document.getElementById('design');
  let mode = 'cart', last = null;

  const radiosOf = (g) => [...g.querySelectorAll('input[type="radio"]')];
  const allGroups = () => (colorGroup ? [colorGroup, ...groups] : groups);
  const chosen = (g) => g.querySelector('input[type="radio"]:checked');
  const pendingGroups = () => allGroups().filter((g) => !chosen(g));
  const legend = (g) => g.querySelector('legend').textContent.trim();
  const selected = () => groups.map((g) => { const c = chosen(g); return c ? c.value : null; });
  const findVariant = (opts) => variants.find((v) => v.options.length === opts.length && v.options.every((o, i) => opts[i] === null || o === opts[i])) || null;
  const optionsPending = () => groups.some((g) => !chosen(g));
  const resolve = () => (groups.length ? (optionsPending() ? null : findVariant(selected())) : variants[0] || null);
  const addLabel = () => (mode === 'checkout' ? 'Payer maintenant' : 'Ajouter au panier');

  const setText = (sel, txt) => $$(sel).forEach((el) => { el.textContent = txt; });
  const setMsg = (txt) => { if (!msg) return; msg.textContent = txt || ''; msg.hidden = !txt; };
  const setSubmit = (disabled, label) => { if (!submit) return; submit.disabled = disabled; submit.textContent = label; };
  const labelOf = () => groups.map((g) => { const c = g.querySelector('input:checked + label'); return c ? c.textContent.trim() : ''; }).filter(Boolean).join(' / ');

  const markAvailability = () => {
    const sel = selected();
    groups.forEach((g, gi) => radiosOf(g).forEach((r) => {
      const probe = sel.slice(); probe[gi] = r.value;
      const v = findVariant(probe);
      r.dataset.state = !v ? 'none' : v.available ? 'ok' : 'soldout';
    }));
  };

  const update = () => {
    const v = resolve();
    markAvailability();
    if (!v && optionsPending()) {          // rien de choisi : aucun id envoyé
      if (idInput) idInput.disabled = true;
      setMsg(''); setText('[data-rz-variant-label]', ''); setSubmit(false, addLabel());
      return null;
    }
    if (!v) {                               // vraie combinaison inexistante
      if (idInput) idInput.disabled = true;
      setMsg('Combinaison indisponible'); setSubmit(true, 'Combinaison indisponible');
      return null;
    }
    setMsg('');
    if (idInput) { idInput.disabled = false; idInput.value = String(v.id); }
    setText('[data-rz-price]', v.price_formatted);
    const hasCompare = v.compare_at_price > v.price;
    $$('[data-rz-compare]').forEach((el) => { el.hidden = !hasCompare; el.textContent = v.compare_at_formatted; });
    $$('[data-rz-save]').forEach((el) => { el.hidden = !hasCompare; });
    if (hasCompare) {
      setText('[data-rz-compare-text]', v.compare_at_formatted);
      setText('[data-rz-percent]', '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %');
    }
    setText('[data-rz-variant-label]', groups.length ? ' · ' + labelOf() : '');
    setSubmit(!v.available, v.available ? addLabel() : 'Épuisé');
    document.dispatchEvent(new CustomEvent('rayzox:variant-change', { detail: { variant: v } }));
    return v;
  };

  // Présélection de la couleur (depuis « Finition ») : option Shopify "Couleur" si elle existe, sinon groupe design.
  const pickColor = (c) => {
    const re = c === 'b' ? /noir|black/i : /blanc|white/i;
    const real = groups.find((g) => /couleur|colou?r/i.test(legend(g)));
    const g = real || colorGroup;
    if (g) radiosOf(g).forEach((r) => { r.checked = re.test(r.value); });
  };

  const lock = (on) => { document.documentElement.style.overflow = on ? 'hidden' : ''; };
  const open = (m, color) => {
    mode = m || 'cart';
    form.querySelectorAll('input[type="radio"]').forEach((r) => { r.checked = false; });
    if (color) pickColor(color);
    update();
    if (ov) { ov.hidden = false; lock(true); }
    last = document.activeElement;
    const first = pendingGroups()[0];
    (first ? radiosOf(first)[0] : submit || form).focus({ preventScroll: true });
  };
  const close = () => { if (!ov) return; ov.hidden = true; lock(false); if (last && last.focus) last.focus(); };

  form.addEventListener('change', (e) => { if (e.target.matches('input[type="radio"]')) update(); });
  if (ov) {
    document.getElementById('rzx').addEventListener('click', close);
    ov.addEventListener('click', (e) => { if (e.target === ov) close(); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !ov.hidden) close(); });
  }

  // Boutons d'achat de la page -> pop-up
  document.addEventListener('click', (e) => {
    if (!ov) return;
    const o = e.target.closest('[data-rz-open]');
    if (o) { e.preventDefault(); open(o.dataset.rzOpen === 'checkout' ? 'checkout' : 'cart'); return; }
    const sw = e.target.closest('.swatch button');                 // Finition : pastille Blanc / Noir
    if (sw) { open('cart', sw.dataset.m === 'b' ? 'b' : 'w'); }
  });
  // Finition : « Acheter la version blanche / noire » (le script de la page ne fait que défiler)
  document.addEventListener('click', (e) => {
    if (!ov || !e.target.closest('#buy')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    open('cart', design && design.dataset.m === 'b' ? 'b' : 'w');
  }, true);

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const v = update();                     // on relit toujours la sélection réelle au moment du clic
    const pending = pendingGroups();
    if (pending.length) {
      const names = pending.length === 1
        ? radiosOf(pending[0]).map((r) => r.nextElementSibling.textContent.trim()).join(' ou ')
        : pending.map((g) => legend(g).toLowerCase()).join(' et ');
      setMsg('Choisissez : ' + names);
      radiosOf(pending[0])[0].focus({ preventScroll: true });
      return;
    }
    if (!v || !v.available) return;
    const item = { id: v.id, quantity: 1 };
    const col = colorGroup && chosen(colorGroup);
    if (col) item.properties = { [legend(colorGroup)]: col.value };
    setSubmit(true, 'Ajout au panier…');
    try {
      const res = await fetch((form.dataset.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || "Impossible d'ajouter au panier");
      const line = (data.items && data.items[0]) || data;
      if (Number(line.variant_id || line.id) !== v.id) throw new Error('Mauvaise variante reçue par le panier, réessayez.');
      location.href = mode === 'checkout' ? (form.dataset.checkoutUrl || '/checkout') : (form.dataset.cartUrl || '/cart');
    } catch (err) {
      update();
      setMsg(err.message || "Impossible d'ajouter au panier");
    }
  });

  update();
})();
